import { useQuery } from '@tanstack/react-query'

import { fetchVenueDashboard } from '@/lib/venue/dashboardApi'
import type { VenueDashboardView } from '@/lib/venue/dashboardTypes'

export function venueDashboardQueryKey(venueId: string) {
  return ['venue', venueId, 'dashboard'] as const
}

export function useVenueDashboard(venueId: string) {
  return useQuery<VenueDashboardView>({
    queryKey: venueDashboardQueryKey(venueId),
    queryFn: () => fetchVenueDashboard(venueId),
  })
}
